import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {
  Route,
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { SecurityService } from './security.service';

@Injectable()
export class SecureGuardService {

  constructor(
    private securityService: SecurityService,
    private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkLogin(state.url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    const url = `/${route.path}`;
    return this.checkLogin(url);
  }

  login() {
    const url = this.router.routerState.snapshot.url;
    this.securityService.logout();
    this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
  }

  checkLogin(url: string): boolean {
    // debugger;
    if (localStorage.getItem('currentUser')) {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
      return false;
    }
  }
}
